import styled from '@emotion/styled';
import FONT from '../../../styles/emotion/fonts';
import COLOR from '../../../styles/emotion/colors';

export const Container = styled.div`
  margin: 8px 32px 32px;
  max-width: 560px;
`;

export const TopSection = styled.div`
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: stretch;
  margin-bottom: 24px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const LeftColumn = styled(Column)`
  flex-basis: 244px;
  flex-grow: 2;
  margin-right: 18px;
`;

export const RightColumn = styled(Column)`
  flex-basis: 216px;
  flex-grow: 1;
  width: 216px;
`;

export const Header = styled.h1`
  font-size: ${FONT.FONT_SIZE_LARGE};
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  line-height: 28px;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: 0 0 8px;
  color: ${COLOR.BLACK};
`;

export const Text = styled.p`
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: ${FONT.FONT_SIZE_LARGE};
  color: ${COLOR.EMPEROR};
  margin-bottom: 12px;
`;

export const Terms = styled.p`
  display: block;
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  line-height: ${FONT.FONT_SIZE_SMALL};
  color: ${COLOR.EMPEROR};
  margin: 0;
`;

export const QRContainer = styled.div`
  align-self: center;
  margin-top: 8px;
  margin-bottom: 20px;
`;

type ImageProps = {
  src: string;
};

export const ImgContainer = styled.div<ImageProps>`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${(props) => props.src});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  div {
    max-width: 100%;
    max-height: 100%;
  }
  div img {
    width: 100%;
    height: 100%;
  }
`;
